import { render } from "./OurPartner.vue?vue&type=template&id=2208e0a6&scoped=true"
import script from "./OurPartner.vue?vue&type=script&lang=js"
export * from "./OurPartner.vue?vue&type=script&lang=js"

import "./OurPartner.vue?vue&type=style&index=0&id=2208e0a6&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2208e0a6"]])

export default __exports__